import React, {Component} from 'react';
import './styles.css';
import CardHelper from '../../helpers';

function CardInfinite(props) {

  const {provider = '', live_enabled = "0"} = props || {};
  // Se toma como referencía cardView para en base a apa saber si se muestra el título o no.
  const isTitleEnabled = CardHelper.posterTitleIsEnabled(provider);


  return (
    <div className={'card card-infinite'}>
      <div className={'card-container'}>
        <div className={'preview-container'}>
          {props.cover !== '' &&
          <div
            className='card-cover'
            style={{ backgroundImage: `url(${props.cover})` }}
          />
          }
          {CardHelper.createBadge(props.badges)}
          <div className='card-labels-container'>
            {CardHelper.createTitle(props.title, isTitleEnabled, live_enabled === "1")}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardInfinite;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardInfinite/index.js